/**
 * Replace .social with .nSocial
 * This is so we can style socials properly without un-styling the default
 */
(() => {
  document.querySelectorAll('.social').forEach((item) => {
    item.classList.remove('social');
    item.classList.add('nSocial');
  });
})();

/**
 * Additional JS Selectors
 */
(() => {
  // add js-target-blank class to parent to allow target blank on 'a' children
  document.querySelectorAll('.js-target-blank a').forEach((item) => {
    item.target = '_blank';
  });

  // add js-customer-tools to element to toggle customer tools slide-in
  (() => {
    document.querySelectorAll('.js-customer-tools').forEach((item) => {
      item.addEventListener('click', () => {
        document.querySelectorAll('.customertools').forEach((tools) => {
          tools.classList.toggle('open');
        });
      });
    });
  })();
})();

/**
 * Footer Links Menu Accordion
 * Add class "foot-menu" to menu widget in footer
 */
(() => {
  document.querySelectorAll('.foot-menu').forEach((item) => {
    item.addEventListener('click', () => {
      item.classList.toggle('open');
    });
  });
})();
